export default __webpack_public_path__ + "img/d04a458daddcf710dfc7b68a7a4d63a9.png";